import { Graphics } from "pixi.js";
import type { Camera } from "../Camera.ts";

interface Star { x: number; y: number; s: number; t: number; layer: number; }

/** Campo de estrelas em 3 camadas com parallax sutil (espaço-tela). */
export class Starfield {
  readonly gfx = new Graphics();
  private stars: Star[] = [];

  constructor(count = 320) {
    for (let i = 0; i < count; i++) {
      const layer = i % 3;
      this.stars.push({
        x: Math.random(), y: Math.random(),
        s: Math.random() * 1.3 + 0.2,
        t: Math.random() * Math.PI * 2,
        layer,
      });
    }
  }

  update(cam: Camera, time: number, W: number, H: number) {
    const g = this.gfx;
    g.clear();
    for (const st of this.stars) {
      const px = st.layer * 0.05 + 0.03;
      const x = (((st.x * W - cam.x * cam.z * px) % W) + W) % W;
      const y = (((st.y * H - cam.y * cam.z * px) % H) + H) % H;
      const tw = 0.35 + 0.65 * Math.abs(Math.sin(time * 0.7 + st.t));
      g.rect(x, y, st.s, st.s).fill({ color: 0xffffff, alpha: tw * (0.16 + st.layer * 0.09) });
    }
  }
}
